<template>
  <div class="participant-app-notification" v-if="ifPanelDeleted">
    <div v-if="!isNotificationAddEdit">
      <div>
        <div class="notification-container row">
          <form class="w100">
            <div class="col-md-4 pull-left mb-10">
              <div>
                <label for="event">Event</label>
                <select name="event" class="form-control" id="event" v-on:change="changEventType($event.target)" v-model="appNotification.eventType">
                  <option value="0">Select event</option>
                  <option value="1" v-if="this.options.telehealthVisit.telehealthVisitDTO.configFor !== 'site'">When it's time to schedule the appointment</option>
                  <option value="2">When it's time for the appointment</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 pull-left mb-10" v-if="appNotification.eventType == '1'">
              <label>Time of day (participant local time)</label>
              <vue-timepicker v-model="appNotification.time" format="hh:mm A" :minute-interval="10" required></vue-timepicker>
            </div>
            <div class="col-md-8 pull-left pr-0 pl-0">
              <label>Message</label>
              <textarea name="message" v-model="appNotification.message" class="form-control text-area-cust-height" placeholder="Time to schedule your video call with your study physician" />
              <p class="form-text text-muted text-right">{{ msgCharCount }}</p>
            </div>
            <div class="col-md-12 pull-left p-0">
              <div>
                <label class="pull-left col-md-4 pl-0" for="occurance">Occurrence</label>
                <div class="sub-heading-survey-notification col-md-8 pl-0">
                  Notification types
                </div>
                <div class="occurance-row row margin-top" v-for="(reminder, index) in occurranceList" :key="index">
                  <div class="occurance-div col-md-4" v-if="appNotification.eventType == 1">
                    <select v-on:change="changeOccurance(index, $event.target)" name="day" class="form-control input-md text-color display-day input-color" v-model="reminder.value">
                      <option value="null" selected>-Select Occurrence-</option>
                      <option :value="type.value" v-for="(type, typeIndex) in remindersList" :key="typeIndex">{{ showDescofOccurence(type) }}</option>
                    </select>
                  </div>
                  <div class="occurance-div col-md-4" v-else>
                    <select v-on:change="changeOccurance(index, $event.target)" name="day" class="form-control input-md text-color display-day input-color" v-model="reminder.value">
                      <option value="null" selected>-Select Occurrence-</option>
                      <option v-for="option in occuranceOptions" v-bind:value="option.value" :data-text="option.text" :key="option.value">
                        {{ option.text }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-8 pl-0 pos_rel">
                    <div class="pull-left mt-10">
                      <div class="pull-left pl-0">
                        <div class="pl-0 pull-left mr-15 custom-noti-lab">
                          App Notification
                        </div>
                        <!-- v-model="prePopulationEnabled" v-on:change="changeStatus" -->
                        <div class="toggle-indicator pull-left mr-5 opacity-change">
                          Off
                        </div>
                        <label class="switch opacity-change pull-left">
                          <input type="checkbox" checked disabled="disabled" />
                          <div class="slider round"></div>
                        </label>
                        <div class="toggle-indicator pull-left ml-5 opacity-change">
                          On
                        </div>
                      </div>
                      <div class="pull-left pl-0 ml-40">
                        <div class="pl-0 pull-left mr-15 custom-noti-lab">
                          Email
                        </div>
                        <div class="toggle-indicator pull-left mr-5">Off</div>
                        <label class="switch pull-left">
                          <input type="checkbox" :disabled="!isMobile" v-model="reminder.emailToggle" />
                          <div class="slider round"></div>
                        </label>
                        <div class="toggle-indicator pull-left ml-5">On</div>
                      </div>
                      <div class="pull-left pl-0 ml-40" v-if="phoneNumberEnable">
                        <div class="pl-0 pull-left mr-15 custom-noti-lab">
                          SMS Text
                        </div>
                        <div class="toggle-indicator pull-left mr-5">Off</div>
                        <label class="switch pull-left">
                          <input type="checkbox" :disabled="!isMobile" v-model="reminder.smsToggle" />
                          <div class="slider round"></div>
                        </label>
                        <div class="toggle-indicator pull-left ml-5">On</div>
                      </div>
                    </div>
                    <div class="occurance-remove-div pull-right pr-20">
                      <img v-on:click="removeOccurance(index)" class="pointer-cursor" v-if="occurranceList.length > 1" src="static/img/collapse.png" />
                    </div>
                  </div>
                </div>
                <a v-if="needToShow" class="link" v-on:click.prevent="addOccurance()">
                  Add another occurrence
                </a>
              </div>
            </div>

            <div class="form-group text-right clr_both mb-0 pt-25">
              <span class="delete-icon" v-on:click="deleteNotification()">
                <img src="static/img/econsent/delete.svg" />
              </span>
              <button class="btn btn-primary" v-on:click.prevent="saveNotification()">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-else>
      <div>
        <div class="notification-container">
          <div class="form-group row">
            <div class="col-md-11 pl-0">
              <label for="event">Event</label>
              <div v-if="appNotification.eventType == 1">
                When it's time to schedule the appointment
              </div>
              <div v-if="appNotification.eventType == 2">
                When its time for the appointment
              </div>
            </div>
            <div class="col-md-1">
              <span for="event" class="link" @click="onEditNotification">Edit</span>
            </div>
          </div>
          <div class="form-group" v-if="appNotification.eventType == 1">
            <label>Time of day (participant local time)</label>
            <div>
              {{ appNotification.time.hh }}:{{ appNotification.time.mm }}
              {{ appNotification.time.A }}
            </div>
          </div>
          <div class="form-group">
            <label>Notification message</label>
            <div>{{ appNotification.message }}</div>
          </div>
          <div class="form-group row">
            <div class="col-md-4">
              <label for="occurance">Occurrence: {{ getOccuranceCount }}</label>
              <div>{{ getOccuranceString }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueTimepicker from "vue2-timepicker";
import swal from "sweetalert2";
import toastr from "toastr";
import _ from "lodash";

export default {
  name: "participant-app-notifications",
  data() {
    return {
      isPanelDisplay: false,
      phoneNumberEnable: false,
      ifPanelDeleted: true,
      isNotificationAddEdit: this.options.appNotification.eventType != 0,
      appNotification: JSON.parse(JSON.stringify(this.options.appNotification)),
      isSaveNotification: false,
      notificationList: [],
      reminderList: this.options.reminderList,
      remindersList: this.options.remindersList,
      completionWindow: this.options.completionWindow,
      advanceScheduleDays: this.options.advanceScheduleDays,
      telehealthReminders: this.options.appNotification.telehealthReminders && this.options.appNotification.telehealthReminders.length > 0 ? this.options.appNotification.telehealthReminders : [],
      occurranceList: this.options.appNotification.occurranceList.length > 0 ? this.options.appNotification.occurranceList : [{ text: null, value: null, smsToggle: false, emailToggle: false }],
      visitId: null,
      studyId: null,
      tempOccurranceList: null,
      eventOptionTypes: {
        2: [
          {
            value: "b-10-d",
            text: "10 days before the appointment time",
            delayType: "before"
          },
          {
            value: "b-7-d",
            text: "7 days before the appointment time",
            delayType: "before"
          },
          {
            value: "b-5-d",
            text: "5 days before the appointment time",
            delayType: "before"
          },
          {
            value: "b-2-d",
            text: "2 days before the appointment time",
            delayType: "before"
          },
          {
            value: "b-1-d",
            text: "1 day before the appointment time",
            delayType: "before"
          },
          {
            value: "b-2-h",
            text: "2 hours before the appointment time",
            delayType: "before"
          },
          {
            value: "b-1-h",
            text: "1 hour before the appointment time",
            delayType: "before"
          },
          {
            value: "b-45-m",
            text: "45 minutes before the appointment time",
            delayType: "before"
          },
          {
            value: "b-30",
            text: "30 min before the appointment time",
            delayType: "before"
          },
          {
            value: "b-15",
            text: "15 min before the appointment time",
            delayType: "before"
          },
          {
            value: "b-10",
            text: "10 min before the appointment time",
            delayType: "before"
          },
          {
            value: "b-5",
            text: "5 min before the appointment time",
            delayType: "before"
          },
          { value: 0, text: "At time of event" },
          {
            value: "a-5",
            text: "5 min after the appointment time (if call has not begun)",
            delayType: "after"
          },
          {
            value: "a-10",
            text: "10 min after the appointment time (if call has not begun)",
            delayType: "after"
          },
          {
            value: "a-15",
            text: "15 min after the appointment time (if call has not begun)",
            delayType: "after"
          },
          {
            value: "a-30",
            text: "30 min after the appointment time (if call has not begun)",
            delayType: "after"
          }
        ]
      },
      getOccurenceData: [],
      siteCallReminders: [],
      copyActualNotificationListData: []
    };
  },
  props: ["options", "studyData"],
  computed: {
    isMobile() {
      if (this.studyData) {
        return !!(this.studyData.android || this.studyData.ios);
      }
      return false;
    },
    needToShow: function() {
      if (this.appNotification.eventType == 2) {
        if (this.occurranceList.length == this.eventOptionTypes[this.appNotification.eventType].length) {
          return false;
        } else {
          return true;
        }
      } else if (this.appNotification.eventType == 1) {
        if (this.remindersList.length == 0) {
          return false;
        } else if (this.occurranceList.length >= this.remindersList.length + 1) {
          return false;
        } else {
          return true;
        }
      }
      return true;
    },
    msgCharCount: function() {
      const charCount = this.appNotification.message && this.appNotification.message.length ? this.appNotification.message.length : 0;
      return charCount === 0 ? "" : `Character count: ${charCount}`;
    },
    occuranceOptions: function() {
      return this.eventOptionTypes[this.appNotification.eventType];
    },
    getOccuranceString: function() {
      let stringText = "";
      for (let i = 0; i < this.telehealthReminders.length; i++) {
        stringText = stringText + ", " + this.telehealthReminders[i].text;
      }
      stringText = stringText.substr(1);
      return stringText;
    },
    getOccuranceCount: function() {
      return this.occurranceList.length;
    }
  },
  components: {
    VueTimepicker
  },
  mounted() {
    this.visitId = window.localStorage.getItem("visitId");
    this.studyId = this.$route.params.studyId;
    const formattedArray = [];
    for (let i = 0; i < this.advanceScheduleDays; i++) {
      const calcValue = 0 - (i + 1);
      formattedArray.push({ name: i + 1, value: calcValue });
    }
    formattedArray.reverse();
    formattedArray.push({ name: "At time of event", value: 0 });
    for (let k = 0; k < this.remindersList.length; k++) {
      formattedArray.push({ name: k + 1, value: k + 1 });
    }
    this.getOccurenceData = [...formattedArray];
    this.remindersList = this.getOccurenceData;
    this.getRegistration();
    this.copyActualNotificationListData = JSON.parse(JSON.stringify(this.options.actualNotificationList));
  },
  watch: {
    options(newValue) {
      this.remindersList = [];
      this.reminderList = newValue.reminderList;
      this.remindersList = newValue.remindersList;
      this.completionWindow = newValue.completionWindow;
      this.advanceScheduleDays = newValue.advanceScheduleDays;
      newValue.completionWindow = Number(newValue.completionWindow) === 0 ? 1 : newValue.completionWindow;
      if (newValue.completionWindow && this.remindersList) {
        this.remindersList.length = Number(newValue.completionWindow) - 1;
      }
      const formattedArray = [];
      for (let i = 0; i < this.advanceScheduleDays; i++) {
        const calcValue = 0 - (i + 1);
        formattedArray.push({ name: i + 1, value: calcValue });
      }
      formattedArray.reverse();
      formattedArray.push({ name: "At time of event", value: 0 });
      for (let k = 0; k < this.remindersList.length; k++) {
        formattedArray.push({ name: k + 1, value: k + 1 });
      }
      this.getOccurenceData = [...formattedArray];
      this.remindersList = this.getOccurenceData;
    }
  },
  methods: {
    truncateText: function(text) {
      if (text.length > 40) {
        return text.substring(0, 40) + "...";
      }
      return text;
    },
    onEditNotification() {
      if (this.occurranceList && this.occurranceList.length > 0) {
        if (this.isMobile == false) {
          this.occurranceList.map(reminder => {
            reminder.smsToggle = false;
            reminder.emailToggle = false;
          });
        }
      }
      // process telehealth reminders
      this.telehealthReminders = [];
      if (this.options.appNotification.eventType == 1) {
        const list = this.notificationList;
        for (let i = 0; i < list.length; i++) {
          this.telehealthReminders.push({
            text: this.getOccuranceText(list[i].day),
            value: list[i].day
          });
        }
      }
      if (this.options.appNotification.eventType == 2) {
        const self = this;
        const occList = [];
        for (let i = 0; i < this.notificationList.length; i++) {
          const time = this.notificationList[i].time;
          const [value] = time.split(" ");
          const eventOptions = this.eventOptionTypes[this.options.appNotification.eventType];
          eventOptions.filter(k => {
            if (value == k.value) {
              self.telehealthReminders.push({
                text: k.text,
                value: value
              });

              occList.push({
                text: k.text,
                value: value
              });
            }
          });
        }
      }
      this.isNotificationAddEdit = !this.isNotificationAddEdit;
      this.isPanelDisplay = true;
    },
    addNewNotification() {
      this.isPanelDisplay = true;
    },
    editNotification() {
      this.isPanelDisplay = true;
    },
    iterateForNotification(isSpliceHappenOld = null, self) {
      let isSpliceHappen = isSpliceHappenOld;
      const that = self;
      that.options.actualNotificationList.forEach(notification => {
        // if occurrance list is present
        for (let i = 0; i < notification.occurranceList.length; i++) {
          if (notification.occurranceList[i].value === null) {
            isSpliceHappen = i;
            continue;
          }
          if (notification.eventType == 1) {
            const timeVal = notification.time;
            that.notificationList.reminder.push({
              time: timeVal.hh + ":" + timeVal.mm + " " + timeVal.A,
              message: notification.message,
              day: parseInt(notification.occurranceList[i].value),
              emailToggle: notification.occurranceList[i].emailToggle,
              smsToggle: notification.occurranceList[i].smsToggle
            });
          }
          if (notification.eventType == 2) {
            const time = notification.occurranceList[i].value != 0 ? notification.occurranceList[i].value.split("-") : notification.occurranceList[i].value;
            let formatTime = "";
            if (time.length === 3) {
              if (time.includes("d")) {
                formatTime = time[1] + " day";
              } else if (time.includes("h")) {
                formatTime = time[1] + " hour";
              } else {
                formatTime = time[1] + " min";
              }
            } else {
              formatTime = (time != 0 ? time[1] : time) + " min";
            }
            that.notificationList.callReminder.push({
              time: formatTime,
              message: notification.message,
              day: 0,
              delayType: time != 0 ? (time[0] == "a" ? "after" : "before") : null,
              emailToggle: notification.occurranceList[i].emailToggle,
              smsToggle: notification.occurranceList[i].smsToggle
            });
          }
        }
        if (isSpliceHappen || isSpliceHappen == 0) {
          that.occurranceList.splice(isSpliceHappen, 1);
        }
      });
    },
    getRegistration() {
      this.$api.getRegistrationFact(this.studyId).then(response => {
        if (response.body.participantRegistrationConfigDetails) {
          const isPhoneEnable = response.body.participantRegistrationConfigDetails.filter(data => data.key === "phoneNumber" && data.isVisible === true);
          if (isPhoneEnable.length > 0) {
            this.phoneNumberEnable = true;
          }
        }
      });
    },
    deleteNotification() {
      const self = this;
      swal({
        title: "Are you sure you want to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.occurranceList = [{ text: null, value: null, showToggle: false, emailToggle: false }];
          this.appNotification.message = "";
          this.appNotification.time = { hh: "", mm: "", A: "" };
          self.ifPanelDeleted = false;
          if (self.options.telehealthVisit.telehealthVisitDTO.configFor == "site") {
            self.notificationList = { reminder: [], callReminder: [] };
            self.iterateForNotification(null, self);

            for (let i = 0; i < self.options.actualNotificationList.length; i++) {
              const obj = {
                message: self.options.actualNotificationList[i].message,
                smsToggle: false,
                emailToggle: false,
                occur: []
              };
              if (self.options.actualNotificationList[i].id) {
                obj.id = self.options.actualNotificationList[i].id;
                const checkChange = self.checkNotificationsChange(self.options.actualNotificationList[i], self.copyActualNotificationListData[i]);
                if (checkChange) {
                  obj.action = "Edited";
                } else {
                  obj.action = "None";
                }
              } else {
                obj.action = "Newer";
              }
              this.formOccurenceListData(self.options.actualNotificationList[i], obj);
              self.options.actualNotificationList.splice(self.options.indexValue, 1);
            }
            self.siteCallReminders[self.options.indexValue].action = "Deleted";
            self.notificationList.siteTaskCallReminders = self.siteCallReminders;
          } else {
            self.options.actualNotificationList.splice(self.options.indexValue, 1);
            self.notificationList = { reminder: [], callReminder: [] };
            self.iterateForNotification(null, self);
          }
          toastr.success("Notification deleted successfully.");
          self.$emit("updateReminder", {
            notificationList: self.notificationList,
            eventType: this.appNotification.eventType,
            action: "delete",
            index: this.options.indexValue,
            actualNotificationList: self.options.actualNotificationList
          });
        } else {
          toastr.warning("Notification not deleted");
        }
      });
    },
    saveNotification() {
      const self = this;
      let isValid = true;
      if (this.appNotification.eventType === 0) {
        isValid = false;
        toastr.error("Notification event is required.");
        return;
      }
      if ((this.appNotification.time.hh === "" || this.appNotification.time.mm === "" || this.appNotification.time.A === "") && this.appNotification.eventType == 1) {
        isValid = false;
        toastr.error("Notification time of day is required.");
        return;
      }

      if (this.appNotification.message == "") {
        isValid = false;
        toastr.error("Notification message is required.");
        return;
      }
      if (this.occurranceList.length === 0 || (this.occurranceList.length == 1 && (this.occurranceList[0].text == null || this.occurranceList[0].value == "null"))) {
        isValid = false;
        toastr.error("Notification Occurrence is required.");
        return;
      }

      if (isValid) {
        this.notificationList = { reminder: [], callReminder: [] };
        // remove local object after save
        this.tempOccurranceList = null;
        const isSpliceHappen = null;

        this.options.actualNotificationList[this.options.indexValue].eventType = this.appNotification.eventType;
        this.options.actualNotificationList[this.options.indexValue].message = this.appNotification.message;
        this.options.actualNotificationList[this.options.indexValue].occurranceList = this.occurranceList;
        this.options.actualNotificationList[this.options.indexValue].time = this.appNotification.time;
        this.options.actualNotificationList[this.options.indexValue].smsToggle = this.appNotification.smsToggle;
        this.options.actualNotificationList[this.options.indexValue].emailToggle = this.appNotification.emailToggle;

        if (this.appNotification.eventType != 0) {
          this.options.actualNotificationList.forEach((notification, index) => {
            if (notification.eventType == self.appNotification.eventType && index != self.options.indexValue) {
              isValid = false;
              toastr.error("This event type is already scheduled. Please select another event.");
              return;
            }
          });
        }
        if (!isValid) {
          return;
        }
        this.iterateForNotification(isSpliceHappen, this);
        this.telehealthReminders = this.occurranceList;
        this.isNotificationAddEdit = true;
        if (this.options.telehealthVisit.telehealthVisitDTO.configFor == "site") {
          for (let i = 0; i < this.options.actualNotificationList.length; i++) {
            const obj = {
              message: this.options.actualNotificationList[i].message,
              smsToggle: false,
              emailToggle: false,
              occur: []
            };
            if (this.options.actualNotificationList[i].id) {
              obj.id = this.options.actualNotificationList[i].id;
              const checkChange = this.checkNotificationsChange(this.options.actualNotificationList[i], this.copyActualNotificationListData[i]);
              if (checkChange) {
                obj.action = "Edited";
              } else {
                obj.action = "None";
              }
            } else {
              obj.action = "Newer";
            }
            this.formOccurenceListData(this.options.actualNotificationList[i], obj);
          }
          this.notificationList.siteTaskCallReminders = this.siteCallReminders;
          this.siteCallReminders = [];
        }
        this.$emit("updateReminder", {
          notificationList: this.notificationList,
          eventType: this.appNotification.eventType,
          index: this.options.indexValue,
          action: "edit",
          actualNotificationList: this.options.actualNotificationList
        });
      }
    },
    addOccurance() {
      this.occurranceList.push({
        value: null,
        text: null,
        smsToggle: false,
        emailToggle: false
      });
    },
    changEventType(element) {
      if (element.value != this.options.appNotification.eventType || this.tempOccurranceList == null) {
        this.tempOccurranceList = this.occurranceList;
        this.occurranceList = [{ text: null, value: null }]; // intialized again
      } else if (element.value == this.options.appNotification.eventType && this.tempOccurranceList != null) {
        this.occurranceList = this.tempOccurranceList;
        this.tempOccurranceList = null;
      }
      if (element.value == 0) {
        this.occurranceList = [{ text: null, value: null, smsToggle: false, emailToggle: false }];
        this.appNotification.time = { hh: "", mm: "", A: "" };
      }
      if (element.value == 1 && this.options.appNotification.eventType == 2) {
        this.appNotification.time = { hh: "", mm: "", A: "" };
      }
      this.appNotification.eventType = element.value;
    },
    removeOccurance(index) {
      const self = this;
      swal({
        title: "Are you sure you want to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          self.occurranceList.splice(index, 1);
          self.remindersList.splice(index, 1);
          toastr.success("Occurrence deleted successfully.");
        } else {
          toastr.warning("Occurrence not deleted.");
        }
      });
    },
    changeOccurance(index, element) {
      const value = element.value;
      if (element.value == "") {
        return;
      }
      for (let i = 0; i < this.occurranceList.length; i++) {
        if (i != index && this.occurranceList[i].value == value) {
          this.occurranceList[index].value = null;
          this.occurranceList[index].text = null;
          this.occurranceList[index].smsToggle = false;
          this.occurranceList[index].emailToggle = false;
          toastr.warning("This is already been selected. Please select another occurrence");
          return;
        }
      }

      this.occurranceList[index].text = this.getOccuranceText(value);
      this.occurranceList[index].value = value;
      this.occurranceList[index].smsToggle = false;
      this.occurranceList[index].emailToggle = false;
    },
    getOccuranceText(value) {
      let stringText = "";
      if (this.appNotification.eventType == 2) {
        const eventOptions = this.eventOptionTypes[this.appNotification.eventType];
        const optionValueObject = eventOptions.filter(c => c.value == value);
        if (optionValueObject != null && optionValueObject.length > 0) {
          stringText = optionValueObject[0].text;
        }
      } else {
        if (value == 0) {
          stringText = "At time of event";
        } else {
          if (value < 0) {
            stringText = Math.abs(value) + " day(s) in advance";
          } else {
            stringText = value + " day(s) after (if not complete)";
          }
        }
      }
      return stringText;
    },
    showDescofOccurence(type) {
      if (type.value < 0) {
        return type.name + " day(s) in advance";
      } else if (type.value > 0) {
        return type.name + " day(s) after (if not complete)";
      } else {
        return type.name;
      }
    },
    formOccurenceListData(notification, obj) {
      const occurenceListData = [];
      for (let i = 0; i < notification.occurranceList.length; i++) {
        const time = notification.occurranceList[i].value != 0 ? notification.occurranceList[i].value.split("-") : notification.occurranceList[i].value;
        let formatTime = "";
        let calculateTimeinMinutes = 0;
        if (time.length === 3) {
          if (time.includes("d")) {
            formatTime = time[1] + " day";
            calculateTimeinMinutes = time[1] * 1440;
          } else if (time.includes("h")) {
            formatTime = time[1] + " hour";
            calculateTimeinMinutes = time[1] * 60;
          } else {
            formatTime = time[1] + " min";
            calculateTimeinMinutes = time[1];
          }
        } else {
          formatTime = (time != 0 ? time[1] : time) + " min";
          calculateTimeinMinutes = formatTime;
        }
        const checkBeforeAfter = time != 0 ? (time[0] == "a" ? "a" : "b") : "b";
        const constructObj = {
          when: time != 0 ? (time[0] == "a" ? "afterApptNotJoined" : "beforeApptTime") : "beforeApptTime",
          timeMinutes: checkBeforeAfter === "a" ? parseInt(calculateTimeinMinutes) : -parseInt(calculateTimeinMinutes),
          smsToggle: notification.occurranceList[i].smsToggle ? notification.occurranceList[i].smsToggle : false,
          emailToggle: notification.occurranceList[i].emailToggle ? notification.occurranceList[i].emailToggle : false
        };
        occurenceListData.push(constructObj);
      }
      obj.occur = occurenceListData;
      this.siteCallReminders.push(obj);
    },
    getObjectDiff(obj1, obj2) {
      const diff = Object.keys(obj1).reduce((result, key) => {
        if (!obj2.hasOwnProperty(key)) {
          result.push(key);
        } else if (_.isEqual(obj1[key], obj2[key])) {
          const resultKeyIndex = result.indexOf(key);
          result.splice(resultKeyIndex, 1);
        }
        return result;
      }, Object.keys(obj2));
      return diff;
    },
    checkNotificationsChange(newObject, OldObject) {
      const compareNotificationsObject = this.getObjectDiff(newObject, OldObject);
      if (compareNotificationsObject.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.margin-top {
  margin-top: 10px;
}
.col-md-4 {
  padding-left: 0;
}
.participant-app-notification {
  margin-top: 30px;
  .font-size-12 {
    font-size: 12px;
  }

  .notification-container {
    background: #ffffff;
    border-radius: 4px;
    border: solid 1px #e4e8eb;
    padding: 20px 21px;
  }
  .link {
    font-weight: bold;
    color: #1e8fe1;
    cursor: pointer;
    top: 10px;
    position: relative;
  }

  label {
    font-weight: bold;
    display: block;
  }

  .btn {
    min-width: 100px;
    height: 34px;
    line-height: inherit;
  }

  button {
    &.btn-primary {
      background-color: #1e8fe1;
      border-color: #1e8fe1;
    }
  }

  .delete-icon {
    cursor: pointer;
    padding: 0px 20px;
    vertical-align: middle;
  }
  .form-group {
    margin-bottom: 1.25rem;
  }

  .occurance-div {
    width: 385px;
    height: 38px;
  }

  .occurance-row {
    width: 100%;
  }

  .occurance-remove-div {
    left: 10px;
    position: relative;
    top: 10px;
  }
  .pointer-cursor {
    cursor: pointer;
  }
}
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  margin-top: -1px;
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}

.bg-green {
  background-color: #2ecc71 !important;
}

.bg-red {
  background-color: #ff7171 !important;
}
.scheduler-heading {
  font-weight: 600;
  color: #666769;
}
.w100 {
  width: 100%;
}
.custom-noti-lab {
  opacity: 0.9;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
  font-family: "RobotoMedium";
}
.toggle-indicator {
  opacity: 0.8;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
.sub-heading-survey-notification {
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #444444;
  font-weight: 600;
  float: left;
}
.pos_rel {
  position: relative;
}

.clr_both {
  clear: both;
}

.opacity-change {
  opacity: 0.5;
}
.text-area-cust-height {
  height: 38px;
}
</style>
